import { Box } from "@mui/system";
import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AlertDesign from "./AlertDesign/TinyEditor";
import ListOfAlerts from "./AlertDesign/ListOfAlerts";
import ListOfSlider from "./SliderSettings/ListOfSlider";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PageRoutes, { UserRoles } from "../../utils/constants";
import UserList from "./UsersList";
import PlayerAlertList from "./PlayerAlertList";
import useCommonDetails from "../../Common/Hooks/useCommonDetails";
import ListOfAds from "./Ads";
import MediaList from "./Media";
import PollList from "./Poll";
import ListOfWhizzard from "./Whizzard";
import useConfig from "../../hooks/useConfig";
import Reports from "./Reports";
import GameSummary from "./GameSummary";
import Geoblocking from "./Rules";
import Games from "./Games";
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Admin = () => {
  const location = useLocation();
  const userDetails = useCommonDetails();
  const [value, setValue] = React.useState<string>(location.pathname);
  const configData = useConfig();
  const hasGeoLocation = ["usah", "dev"].includes(configData.name);
  const navigate = useNavigate();
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
    setValue(newValue);
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box
        sx={{
          flexGrow: 1,
          fontStyle: "normal !important",
        }}
      >
        <Tabs
          orientation="horizontal"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Announcement" value={PageRoutes.Admin} />}{" "}
          {[
            UserRoles.HTP_ADMIN,
            UserRoles.LEAGUE_ADMIN,
            UserRoles.CUSTOMER_ADMIN,
          ].includes(userDetails?.UserRoleID) && (
            <Tab label="Sliders" value={PageRoutes.SliderSetting} />
          )}
          {[UserRoles.HTP_ADMIN].includes(userDetails?.UserRoleID) && (
            <Tab label="Users" value={PageRoutes.Users} />
          )}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Player Overlays" value={PageRoutes.PlayerAlerts} />}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Polls" value={PageRoutes.Polls} />}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Prerolls" value={PageRoutes.Ads} />}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) &&
            process.env.REACT_APP_INSIDER == "true" &&
            ["nahl", "dev", "ssm", "usah"].includes(configData.name) && (
              <Tab label="Whizzard" value={PageRoutes.Whizzard} />
            )}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Library" value={PageRoutes.Media} />}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) && <Tab label="Reports" value={PageRoutes.Reports} />}
          {[UserRoles.HTP_ADMIN, UserRoles.LEAGUE_ADMIN].includes(
            userDetails?.UserRoleID
          ) &&
            ["nahl", "dev"].includes(configData.name) && (
              <Tab label="Game Summary" value={PageRoutes.GameSummary} />
            )}
          {hasGeoLocation && (
            <Tab label="Geoblocking" value={PageRoutes.Rules} />
          )}
          {hasGeoLocation && <Tab label="Games" value={PageRoutes.Games} />}
        </Tabs>
        <TabPanel value={value} index={PageRoutes.Admin}>
          <ListOfAlerts />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.SliderSetting}>
          <ListOfSlider />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.Users}>
          <UserList />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.PlayerAlerts}>
          <PlayerAlertList />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.Polls}>
          <PollList />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.Ads}>
          <ListOfAds />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.Whizzard}>
          <ListOfWhizzard />
        </TabPanel>

        <TabPanel value={value} index={PageRoutes.Media}>
          <MediaList />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.Reports}>
          <Reports />
        </TabPanel>
        <TabPanel value={value} index={PageRoutes.GameSummary}>
          <GameSummary />
        </TabPanel>
        {hasGeoLocation && (
          <TabPanel value={value} index={PageRoutes.Rules}>
            <Geoblocking />
          </TabPanel>
        )}
        {hasGeoLocation && (
          <TabPanel value={value} index={PageRoutes.Games}>
            <Games />
          </TabPanel>
        )}
      </Box>
    </Box>
  );
};
export default Admin;
